import React from 'react'
import { useDraggable } from '@dnd-kit/core'
import { Box } from '@mui/material'
import { CSS } from '@dnd-kit/utilities'

function Draggable (props) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id
  })

  const style = {
    flex: 1,
    transform: CSS.Translate.toString(transform)
  }

  return (
    <Box ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </Box>
  )
}

export default Draggable
